module.exports = __webpack_public_path__ + "static/img/coupon_bg_zh_invalid.4ca84615.png";